import { render, staticRenderFns } from "./FixedCostCustomerList.vue?vue&type=template&id=aff612ea&scoped=true&"
import script from "./FixedCostCustomerList.vue?vue&type=script&lang=js&"
export * from "./FixedCostCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./FixedCostCustomerList.vue?vue&type=style&index=0&id=aff612ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff612ea",
  null
  
)

export default component.exports